import React, { useCallback, useState } from 'react'
import useRemoveItemsCallback from '../../../../hooks/actions/useRemoveItemsCallback'
import RemoveButton from './RemoveButton'
import RemoveFromCartWmo from './RemoveFromCartWmo'
import useWmoEnabled from '../../../../../../hooks/useWmoEnabled'
import { PromotionStorageManager } from '../../../../../../helpers/promotions'

const RemoveFromCart = props => {
  const {
    index,
    data,
  } = props

  const isWmoEnabled = useWmoEnabled()
  const [removingItem, setRemovingItem] = useState(false)

  const removeItems = useRemoveItemsCallback(setRemovingItem)

  const handleAction = useCallback(
    () => {
      const items = [{ ...data }]
      removeItems(items).then((res) => {
        const sku = data?.product?.sku
        if(sku) {
          const promoManager = new PromotionStorageManager()
          promoManager.deletePromoItemBySku(sku)
        }
        // Adjust spark widget position on cart empty
        if(res?.items?.length === 0) {
         	window.dispatchEvent(new Event("cart_emptied"));
        }
      })
    },
    [removeItems, data],
  )

  if (isWmoEnabled) {
    return <RemoveFromCartWmo index={index} handleAction={handleAction} removingItem={removingItem} />
  }

  return (
    <RemoveButton
      data={data}
      index={index}
      removeItemHandler={handleAction}
    />
  )
}

export default RemoveFromCart
